module.exports = __webpack_public_path__ + "img/15.db2f6cef.png";